import {
  FilterCancellation as BaseFilterCancellation,
  type FilterCancellationProps,
} from "@tenant/hotels";

export const FilterCancellation = (props: FilterCancellationProps) => {
  return <BaseFilterCancellation {...props} />;
};
